import React from "react";
import { Card, Col, Row, Statistic } from "antd";
import styled from "styled-components";

function SectionTitle({ children }) {
  return <SectionLabel>{children}</SectionLabel>;
}

function StatCard({ title, value, suffix }) {
  return (
    <Col xs={12} sm={8} md={6} xl={4}>
      <Card size="small" bordered>
        <Statistic title={title} value={value} suffix={suffix} />
      </Card>
    </Col>
  );
}

function StatsDashboard({ stats }) {
  if (!stats) return null;

  const { users, activity, license, analyses } = stats;

  return (
    <Wrapper>
      <SectionTitle>회원 현황</SectionTitle>
      <Row gutter={[12, 12]}>
        <StatCard title="활성 회원" value={users.total_active} suffix="명" />
        <StatCard title="삭제됨" value={users.total_deleted} suffix="명" />
        <StatCard title="개인 회원" value={users.individual} suffix="명" />
        <StatCard title="기관 회원" value={users.organization} suffix="명" />
        <StatCard title="관리자" value={users.admin} suffix="명" />
      </Row>

      <SectionTitle>활동</SectionTitle>
      <Row gutter={[12, 12]}>
        <StatCard title="최근 7일 신규 가입" value={activity.new_7d} suffix="명" />
        <StatCard title="최근 30일 신규 가입" value={activity.new_30d} suffix="명" />
        <StatCard title="최근 7일 접속" value={activity.active_7d} suffix="명" />
        <StatCard title="최근 30일 접속" value={activity.active_30d} suffix="명" />
      </Row>

      <SectionTitle>라이센스 (admin 제외)</SectionTitle>
      <Row gutter={[12, 12]}>
        <StatCard title="KLA 유효" value={license.kla_active} suffix="명" />
        <StatCard title="SLE 유효" value={license.sle_active} suffix="명" />
        <StatCard
          title="KLA 30일 내 만료"
          value={license.kla_expiring_30d}
          suffix="명"
        />
        <StatCard
          title="SLE 30일 내 만료"
          value={license.sle_expiring_30d}
          suffix="명"
        />
      </Row>

      <SectionTitle>분석 활동 (data 테이블)</SectionTitle>
      <Row gutter={[12, 12]}>
        <StatCard title="전체 분석 건수" value={analyses.total} suffix="건" />
        <StatCard title="최근 30일" value={analyses.last_30d} suffix="건" />
        <StatCard title="최근 7일" value={analyses.last_7d} suffix="건" />
      </Row>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-bottom: 24px;
`;

const SectionLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary, #555);
  margin: 16px 0 8px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

export default StatsDashboard;
